export default __webpack_public_path__ + "static/media/QQTDemowithNestingandCC.1a9cd814.mp4";